export default {
    methods: {
        async reloadTable() {
            await this.$mitt.emit('reloadIndexTable')
        },
    },
}
